import { keysToCamelCase } from "@jti/fe-common";
export const getConsumablesMatrixResponseMock = () => ({
    getConsumablesMatrix: {
        packagingFormats: [
            {
                id: "1",
                label: "Single pack",
                contentsType: "pack",
                itemsPerPackage: 10,
                packagesPerBundle: 1,
                productTypeName: "simple",
                icon: "https://m24-fe1.dev-jtides.com/media/jti_selector_matrix/icons/Screenshot_2025-05-13_at_03.08.49.png",
                formatQuantity: 1,
            },
            {
                id: "2",
                label: "10 packs Carton",
                contentsType: "carton",
                itemsPerPackage: 20,
                packagesPerBundle: 10,
                productTypeName: "bundle",
                icon: "https://m24-fe1.dev-jtides.com/media/jti_selector_matrix/icons/2_2.jpg",
                formatQuantity: 5,
            },
            {
                id: "3",
                label: "10 packs mix & match",
                contentsType: "mixed",
                itemsPerPackage: 20,
                packagesPerBundle: 10,
                productTypeName: "bundle",
                icon: "https://m24-fe1.dev-jtides.com/media/jti_selector_matrix/icons/mnm.jpg",
                formatQuantity: 10,
            },
            {
                id: "4",
                label: "5 pack mix & match",
                contentsType: "mixed",
                itemsPerPackage: 20,
                packagesPerBundle: 5,
                productTypeName: "bundle",
                icon: "https://m24-fe1.dev-jtides.com/media/jti_selector_matrix/icons/mnm_1.jpg",
                formatQuantity: 5,
            },
        ],
        items: [
            {
                sku: "consumables-sticks-pack-bronze",
                packagingFormatId: "1",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 14,
                    flavour_label: "Bronze",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-pack-gold",
                packagingFormatId: "1",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 13,
                    flavour_label: "Gold",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-pack-silver",
                packagingFormatId: "1",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 15,
                    flavour_label: "Silver",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-pack-amber",
                packagingFormatId: "1",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 16,
                    flavour_label: "Amber",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-pack-tan",
                packagingFormatId: "1",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 37,
                    flavour_label: "Tan",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-pack-burgundy",
                packagingFormatId: "1",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 40,
                    flavour_label: "Burgundy",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-carton-bronze",
                packagingFormatId: "2",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 14,
                    flavour_label: "Bronze",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-carton-bronze-subscription",
                packagingFormatId: "2",
                purchaseType: "subscription",
                flavorDetails: {
                    flavour: 14,
                    flavour_label: "Bronze",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-carton-gold",
                packagingFormatId: "2",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 13,
                    flavour_label: "Gold",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-carton-gold-subscription",
                packagingFormatId: "2",
                purchaseType: "subscription",
                flavorDetails: {
                    flavour: 13,
                    flavour_label: "Gold",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-carton-silver",
                packagingFormatId: "2",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 15,
                    flavour_label: "Silver",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-carton-silver-subscription",
                packagingFormatId: "2",
                purchaseType: "subscription",
                flavorDetails: {
                    flavour: 15,
                    flavour_label: "Silver",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-carton-amber",
                packagingFormatId: "2",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 16,
                    flavour_label: "Amber",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-carton-amber-subscription",
                packagingFormatId: "2",
                purchaseType: "subscription",
                flavorDetails: {
                    flavour: 16,
                    flavour_label: "Amber",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-carton-tan",
                packagingFormatId: "2",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 37,
                    flavour_label: "Tan",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-carton-tan-subscription",
                packagingFormatId: "2",
                purchaseType: "subscription",
                flavorDetails: {
                    flavour: 37,
                    flavour_label: "Tan",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-carton-burgundy",
                packagingFormatId: "2",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 40,
                    flavour_label: "Burgundy",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-sticks-carton-burgundy-subscription",
                packagingFormatId: "2",
                purchaseType: "subscription",
                flavorDetails: {
                    flavour: 40,
                    flavour_label: "Burgundy",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-10-sticks-mix-n-match",
                packagingFormatId: "3",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 15,
                    flavour_label: "Silver",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-10-sticks-mix-n-match-subscription",
                packagingFormatId: "3",
                purchaseType: "subscription",
                flavorDetails: {
                    flavour: 15,
                    flavour_label: "Silver",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-5-sticks-mix-n-match",
                packagingFormatId: "4",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 15,
                    flavour_label: "Silver",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-5-sticks-mix-n-match-subscription",
                packagingFormatId: "4",
                purchaseType: "subscription",
                flavorDetails: {
                    flavour: 15,
                    flavour_label: "Silver",
                    swatch_data: "#030003",
                },
            },
            {
                sku: "consumables-10-sticks-mix-n-match",
                packagingFormatId: "3",
                purchaseType: "regular",
                flavorDetails: {
                    flavour: 999,
                    flavour_label: "",
                    swatch_data: "#030003",
                },
            },
        ],
    },
});
export const getConsumablesMatrixFormattedResponseMock = () => keysToCamelCase(getConsumablesMatrixResponseMock().getConsumablesMatrix);
//# sourceMappingURL=getConsumablesMatrixResponse.mock.js.map